import React, { useState } from 'react'
import Dashboard from './Dashboard'
import AggregatorInfoMain from './AggregatorDetails/Main'
import AddaggregatorMain from './AddScreen/AddAggregators/Main'
export default function Main({handleBack, handleFilter, commonFilter}) {
    const [tab, setTab] = useState("dashboard")
    const [infoData,setInfoData] =useState({})

    const handleTab = (type,data)=>{
        setInfoData(data)
        setTimeout(()=>{
            setTab(type)
        },200)
    }

    
    return (
        <>
            {
                tab == "dashboard" ?
                    <Dashboard handleTab={handleTab} handleBack={handleBack} handleFilter={handleFilter} commonFilter={commonFilter}/>
                    : ""}
            {
                tab == "view" ?
                    <AggregatorInfoMain handleBack={handleTab} Data={infoData} commonFilter={commonFilter} handleFilter={handleFilter}/>
                    : ""}
            {
                tab == "add" ?
                    <AddaggregatorMain handleBack={handleTab} Data={infoData} />
                    : ""}
        </>
    )
}
